import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";
import { apiGet, apiPut } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getUserSurveyFromAPI = async (user_survey_id) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet(`/usersurveys/${user_survey_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const updateUserSurveyFromAPI = async (user_survey_id, obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPut(`/usersurveys/${user_survey_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
